// @ts-nocheck
import {Column} from 'react-table'
import {AdministratorInfoCell} from './AdministratorInfoCell'
import {AdministratorStatusCell} from './AdministratorStatusCell'
import {AdministratorCustomHeader} from './AdministratorCustomHeader'
import {Administrator} from '../../core/_models'
import {AdministratorDocumentNumberCell} from './AdministratorDocumentNumberCell'
import {AdministratorIdCell} from './AdministratorIdCell'
import {AdministratorActionsCell} from './AdministratorActionsCell'
import {AdministratorGenericCell} from './AdministratorGenericCell'
import {AdministratorDateCell} from './AdministratorDateCell'

const administratorsColumns: ReadonlyArray<Column<Administrator>> = [
  {
    Header: (props) => (
      <AdministratorCustomHeader tableProps={props} title='ID' className='min-w-25px' />
    ),
    id: 'id',
    Cell: ({...props}) => <AdministratorIdCell administrator={props.data[props.row.index]} />,
  },
  {
    Header: (props) => (
      <AdministratorCustomHeader tableProps={props} title='Administrador' className='min-w-125px' />
    ),
    id: 'name',
    Cell: ({...props}) => <AdministratorInfoCell administrator={props.data[props.row.index]} />,
  },
  {
    Header: (props) => (
      <AdministratorCustomHeader tableProps={props} title='E-mail' className='min-w-90px' />
    ),
    id: 'email',
    Cell: ({...props}) => <AdministratorGenericCell labelName={props.data[props.row.index].email} />,
  },
  {
    Header: (props) => (
      <AdministratorCustomHeader tableProps={props} title='Documento' className='min-w-90px' />
    ),
    id: 'type',
    Cell: ({...props}) => <AdministratorDocumentNumberCell administrator={props.data[props.row.index]} />,
  },
  {
    Header: (props) => (
      <AdministratorCustomHeader tableProps={props} title='Novo' className='min-w-90px' />
    ),
    id: 'is_new_user',
    Cell: ({...props}) => <AdministratorGenericCell labelName={props.data[props.row.index].is_new_user ? 'Sim' : 'Não'} />,
  },
  {
    Header: (props) => (
      <AdministratorCustomHeader tableProps={props} title='Status' className='min-w-20px' />
    ),
    id: 'status_name',
    Cell: ({...props}) => <AdministratorStatusCell administrator={props.data[props.row.index]} />,
  },
  {
    Header: (props) => (
      <AdministratorCustomHeader tableProps={props} title='Criado Em' className='min-w-20px' />
    ),
    id: 'created_at',
    Cell: ({...props}) => <AdministratorDateCell customDate={props.data[props.row.index].created_at} />,
  },
  {
    Header: (props) => (
      <AdministratorCustomHeader tableProps={props} title='Ações' className='text-end min-w-100px' />
    ),
    id: 'actions',
    Cell: ({...props}) => (
      <AdministratorActionsCell administrator={props.data[props.row.index]}
      />
    ),
  },
]

export {administratorsColumns}
